import { render, staticRenderFns } from "./Processando.vue?vue&type=template&id=2ffb295c&scoped=true&"
import script from "./Processando.vue?vue&type=script&lang=js&"
export * from "./Processando.vue?vue&type=script&lang=js&"
import style0 from "./Processando.vue?vue&type=style&index=0&id=2ffb295c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffb295c",
  null
  
)

export default component.exports